import { render } from "./EvolutionTypeSwitcher.vue?vue&type=template&id=085a791c&scoped=true"
import script from "./EvolutionTypeSwitcher.vue?vue&type=script&lang=js"
export * from "./EvolutionTypeSwitcher.vue?vue&type=script&lang=js"

import "./EvolutionTypeSwitcher.vue?vue&type=style&index=0&id=085a791c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085a791c"]])

export default __exports__